import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "officina_token";
const ACCESS_CODE_KEY = "officina_access_code";
const TRUSTED_DEVICE_KEY = "officina_trusted_device_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getAccessCode() {
  return localStorage.getItem(ACCESS_CODE_KEY);
}
export function setAccessCode(c) {
  if (c) localStorage.setItem(ACCESS_CODE_KEY, c);
  else localStorage.removeItem(ACCESS_CODE_KEY);
}

export function getTrustedDeviceToken() {
  return localStorage.getItem(TRUSTED_DEVICE_KEY);
}
export function setTrustedDeviceToken(t) {
  if (t) localStorage.setItem(TRUSTED_DEVICE_KEY, t);
  else localStorage.removeItem(TRUSTED_DEVICE_KEY);
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  const ac = getAccessCode();
  if (ac) config.headers["X-Access-Code"] = ac;
  const td = getTrustedDeviceToken();
  if (td) config.headers["X-Trusted-Device"] = td;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Format an ISO date string (YYYY-MM-DD or full ISO) to Italian dd/mm/yyyy.
 * Returns "—" if invalid/empty.
 */
export function formatDateIT(iso) {
  if (!iso) return "—";
  try {
    const s = String(iso);
    // If pure YYYY-MM-DD without time, avoid TZ shifts
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [y, m, d] = s.split("-");
      return `${d}/${m}/${y}`;
    }
    const d = new Date(s);
    if (isNaN(d.getTime())) return String(iso);
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return String(iso);
  }
}

/**
 * Format ISO datetime to Italian dd/mm/yyyy HH:mm.
 */
export function formatDateTimeIT(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    const date = d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
    const time = d.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
    return `${date} ${time}`;
  } catch {
    return String(iso);
  }
}

